
<link href="../../../assets/css/index.css" rel="stylesheet" type="text/css" />
<link href="../../../assets/css/animate.min.css" rel="stylesheet" type="text/css" />

<!--头部begin-->
<div class="indexBody">
  <div class="topBG top2 page-header navbar navbar-fixed-top" style="z-index: 999;">

    <div class="w1180">
      <div class="LogoBox" style="line-height: 64px;">
        <a [routerLink]="['/']" class="logoCreditVanes">
          <img src="../../../assets/images/sysLogoBlue.png" alt="LOGO" style="vertical-align: bottom;"/>
        </a>
      </div>
      <div class="topUserBG page-header-inner">
        <nz-badge *ngIf="globalService.getValue('countShow')" [title]="'您有'+messageCount+'条未读消息'" [routerLink]="['/MemberCenterParent/myMessageList']" [nzCount]="messageCount" [nzOverflowCount]="99" style="position: absolute;
    z-index: 1;
    left: 12px;
    cursor: pointer;
    top: 20px;">
          <a class="head-example"></a>
        </nz-badge>
        <!--登录后begin-->
        <div class="top1 top-menu" *ngIf="globalService.isLoginedUser">
          <ul class="nav navbar-nav pull-right">
            <li class="dropdown dropdown-user">
              <nz-dropdown><!--nzTrigger="click"-->
                <a class="ant-dropdown-link humanName" nz-dropdown>
                  <span class="username username-hide-on-mobile">
                    <div class="floatL navHeadBox">
                      <img src="../../../assets/images/btnLogAiconDark.png" class="navHead" align="absmiddle" /><!--<span class="navNum">1</span>-->
                    </div>
                  </span>
                  <span class="humanNameText" *ngIf="globalService.getUserInfo('_userType') == 'enterprise' ||
                                                     globalService.getUserInfo('_userType') == 'person'">{{globalService.getUserInfo("_userName")}}</span>
                  <i class="anticon anticon-down"></i>
                </a>
                <ul nz-menu class="topNavUl" >
                  <li nz-menu-item *ngIf="globalService.getUserInfo('_userType') == 'enterprise'">
                    <a rel="noopener noreferrer" [routerLink]="['/enterpIntroduction/enterpBasicArchives']" [queryParams]="{aType:1}">
                      <img src="../../../assets/images/navLogZY.png" align="absmiddle"/>
                      <span>我的主页</span>
                    </a>
                  </li>
                  <li nz-menu-item>
                    <a rel="noopener noreferrer" [routerLink]="[memberCenterUrl]">
                      <img src="../../../assets/images/navLogCus.png" align="absmiddle"/>
                      <span>会员中心</span>
                    </a>
                  </li>
                  <li nz-menu-item>
                    <a rel="noopener noreferrer" [routerLink]="['/helpCenter/platformIntroduction']">
                      <img src="../../../assets/images/navLogHelp.png" align="absmiddle"/>
                      <span>帮助中心</span>
                    </a>
                  </li>
                  <li nz-menu-item>
                    <a rel="noopener noreferrer" (click)="loginOut()">
                      <img src="../../../assets/images/navLogExit.png" align="absmiddle"/>
                      <span>退出登录</span>
                    </a>
                  </li>
                </ul>
              </nz-dropdown>
            </li>
          </ul>
          <div class="push"></div>
        </div>
        <div class="topUser" *ngIf="!globalService.isLoginedUser">
          <button class="btnLogA" id="openLoginTC" [routerLink]="['/comLR/login']">登录</button>&nbsp;&nbsp;<button class="btnLogA" id="openRegTC" [routerLink]="['/comLR/register']">注册
        </button>&nbsp;&nbsp;<img class="btnLogAicon" src="../../../assets/images/btnHelpBlue.png" align="absmiddle" alt="" (click)="helpCentern()" />
        </div>
        <!--登录后over-->
      </div>
      <div class="headMenu">
        <ul class="hmenu">
          <!--<li class="current first">
            <a [routerLink]="['/']" target="_self">首页</a>
          </li>-->
          <!--<li class="li_1">
            <a [routerLink]="['/CityEnterApply']" target="_blank">城市入驻</a>
          </li>-->
          <li class="li_1">
            <a [routerLink]="['/searchParent']" target="_blank">信用查询</a>
          </li>
          <li class="li_1">
            <a [routerLink]="['/creditNews']" target="_blank">信用发布</a>
          </li>
          <li class="li_1">
            <a [routerLink]="['/cityCredit']" target="_self">城市信用</a>
          </li>
          <li class="li_1">
            <a [routerLink]="['/newsListZ']" [queryParams]="{type:9}" target="_blank">政务诚信</a>
          </li>
          <li class="li_1">
            <a [routerLink]="['/newsList']" [queryParams]="{type:10}" target="_blank">行业信用</a>
          </li>
          <li class="li_1">
            <a [routerLink]="['/redAndBlackList/taxableEnterpList']"  target="_blank">红黑名单</a>
          </li>
          <!--放出-->
          <li class="li_1">
            <a href="http://credit.xinhua08.com/" target="_blank">信用资讯</a>
          </li>
          <li class="li_1">
            <a href="http://silkroad.news.cn/" target="_blank">新华丝路</a>
          </li>
          <!--<li class="li_1">-->
          <!--<a [routerLink]="['/dataScreen']">信用管理</a>-->
          <!--</li>-->
          <!--<li class="li_1">-->
          <!--<a [routerLink]="['/creditStandard']" target="_blank">信用标准</a>-->
          <!--</li>-->
        </ul>
        <div class="push"></div>
      </div>
      <div class="push">
        <!--清浮动勿删-->
      </div>
    </div>
  </div>

  <!--头部over-->
  <div class="indContainer">

    <div class="indContainerBG">
      <img src="../../../assets/images/bg-new.jpg" alt="" />
    </div>

    <div class="indContain">
      <div class="indContainL">
        <!--竖着翻半屏 begin-->
        <div class="iVscrollBox">
          <!--圈-->
          <div class="indPublishBox">
            <ul class="iVscrollTits">
              <!--标题们-->
              <li class="iVtit iVtit1 active" >
                <dl class="timeLight" (mouseover)="over(0)" (mouseout)="out(0)" ><a [routerLink]="['/creditCard']" target="_blank" >
                  <dd>
                    <img src="../../../assets/images/indXYMPHov.png" class="productPic" alt="信用名片" />
                    <img src="../../../assets/images/indXYMP.png" class="productPicHov" alt="信用名片" />
                  </dd>
                  <dt>
                    企业名片
                  </dt></a>
                </dl>
              </li>
              <li class="iVtit iVtit2" >
                <dl (mouseover)="over(1)" (mouseout)="out(1)" ><a>
                  <dd>
                    <img src="../../../assets/images/indXYPFHov.png" class="productPic" alt="信用评分" />
                    <img src="../../../assets/images/indXYPF.png" class="productPicHov" alt="信用评分" />
                  </dd>
                  <dt>
                    信用评价
                  </dt></a>
                </dl>
              </li>
              <li class="iVtit iVtit3" >
                <dl (mouseover)="over(2)" (mouseout)="out(2)" ><a [routerLink]="['/helpCenter/aboutReports']" target="_blank" >
                  <dd>
                    <img src="../../../assets/images/indXYBZHov.png" class="productPic" alt="信用报告" />
                    <img src="../../../assets/images/indXYBZ.png" class="productPicHov" alt="信用报告" />
                  </dd>
                  <dt>
                    信用报告
                  </dt></a>
                </dl>
              </li>
              <li class="iVtit iVtit4" >
                <dl (mouseover)="over(3)" (mouseout)="out(3)" ><a>
                  <dd>
                    <img src="../../../assets/images/indXYTPHov.png" class="productPic" alt="信用图谱" />
                    <img src="../../../assets/images/indXYTP.png" class="productPicHov" alt="信用图谱" />
                  </dd>
                  <dt>
                    信用图谱
                  </dt></a>
                </dl>
              </li>
              <li class="iVtit iVtit6" >
                <dl (mouseover)="over(4)" (mouseout)="out(4)" ><a>
                  <dd>
                    <img src="../../../assets/images/indXYJCHov.png" class="productPic" alt="信用监测" />
                    <img src="../../../assets/images/indXYJC.png" class="productPicHov" alt="信用监测" />
                  </dd>
                  <dt>
                    信用监测
                  </dt></a>
                </dl>
              </li>
              <li class="iVtit iVtit7" >
                <dl (mouseover)="over(5)" (mouseout)="out(5)" ><a>
                  <dd>
                    <img src="../../../assets/images/indXYJCHov.png" class="productPic" alt="最新入驻" />
                    <img src="../../../assets/images/indXYJC.png" class="productPicHov" alt="最新入驻" />
                  </dd>
                  <dt>
                    最新入驻
                  </dt></a>
                </dl>
              </li>
            </ul>
          </div>

          <div class="iVscrollCons animated fadeInLeft" >
            <div>
              <div class="iVscrollCon iVscrollCon1">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>企业名片</h2>
                  <div class="marB10">
                    <p class="in0">
                      企业名片是企业社交功能的载体，具有宣传和推介的作用，用户通过企业名片管理功能创建及修改企业名片，上传信息包括企业基本信息与发展历程、产品服务与照片墙、资质信息与企业视界等。
                    </p>
                  </div>
                  <div class="marB10"><img src="../../../assets/images/pp-card.png" alt="" width="100%" /></div>
                </div>
              </div>
              <!--这里放其他6块内容，待设计再放-->
              <div class="iVscrollCon iVscrollCon1" style="display: none;">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>信用评价</h2>
                  <div class="marB10">
                    <p class="in0">
                      结合企业的各类公开信息，给出企业信用评价相关信息及图示，展现企业多个维度的风险评估、企业信用行业排名和地区排名，做到多领域、全方位、精准覆盖企业信用状况，给出合理企业信用评价。
                    </p>
                  </div>
                  <div class="marB10"><img src="../../../assets/images/pp-grade.png" alt="" width="100%" /></div>
                </div>
              </div>

              <div class="iVscrollCon iVscrollCon1" style="display: none;">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>信用报告</h2>
                  <div class="marB10">
                    <p class="in0">
                      作为征信机构的核心业务，提供广领域、多类别、各层次的信用报告，包括征信报告、评级报告、信用调查报告等。
                    </p>
                  </div>
                  <div class="marB10"><img src="../../../assets/images/pp-report.gif" alt="" width="100%" /></div>
                </div>
              </div>

              <div class="iVscrollCon iVscrollCon1" style="display: none;">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>信用图谱</h2>
                  <div class="marB10">
                    <p class="in0">
                      信用图谱整合企业公开信息，挖掘海量非结构化数据，通过多维交叉分析及智能算法构建企业的轮廓，提供洞察企业客户画像及关联关系的工具。深度挖掘企业风险隐患、成长潜力、隐形关系、产业链上下游。
                    </p>
                  </div>
                  <div class="marB10"><img src="../../../assets/images/pp-atlas.png" alt="" width="100%" /></div>
                </div>
              </div>

              <div class="iVscrollCon iVscrollCon1" style="display: none;">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>信用监测</h2>
                  <div class="marB10">
                    <p class="in0">
                      基于企业多维大数据平台，依靠新华风控模型，自动识别风险因子，对风险因子进行量化处理，并结合企业自身发展，为用户提供信用风险管控服务 的SAAS平台，是新华信用在征信领域的最佳实践。
                    </p>
                  </div>
                  <div class="marB10"><img src="../../../assets/images/pp-monitor.png" alt="" width="100%" /></div>
                </div>
              </div>

              <div class="iVscrollCon iVscrollCon1" style="display: none;">
                <div class="iLmod1 padR20" (mouseover)="over(10)" (mouseout)="out(10)">
                  <h2>最新入驻企业</h2>
                  <div class="marB10">
                    <table>
                      <tr *ngFor="let item of rzList"  style="margin: 10px 0px;" >
                        <td width="100%" style="padding: 6px 0px;">
                          <table width="100%" >
                            <tr>
                              <td colspan="2"><a [routerLink]="['/enterpIntroduction/enterpBasicArchives']" [queryParams]="{companyId:item.companyId}" target="_blank"><p class="in0" style="font-size: 16px;">{{item.enterInfo?.name}}</p></a></td>
                            </tr>
                            <tr>
                              <td width="50%" nowrap="*">法定代表人：{{item.enterInfo?.operName}}</td>
                              <td width="50%" nowrap="*" *ngIf="item.enterInfo?.startDate">成立时间：{{item.enterInfo?.startDate.substring(0,10)}}</td>
                              <td width="50%" nowrap="*" *ngIf="!item.enterInfo?.startDate">成立时间：-</td>
                              <!--<td width="33%" nowrap="*">注册资本：{{item.enterInfo?.registCapi}}</td>-->
                            </tr>
                            <tr><td colspan="2" nowrap="*">地址：{{item.enterInfo?.address}}</td></tr>
                          </table>
                        </td>
                      </tr>
                    </table>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <!--竖着翻半屏 over-->

      </div>

      <div class="indContainR animated fadeInLeft">
        <div class="indContainRcon">
          <!--新加的标题-->
          <div class="new"> <h2>最新发布</h2> </div>
          <!--新闻左右翻 begin-->
          <div class="indNewsMod1" >
            <div class="yx-rotaion">
              <ul class="rotaion_list">
                <span *ngFor="let item of newsList; let i=index" >
                <li *ngIf="i < 6">
                  <a target="_blank"
                     [routerLink]="['/newsDetail']"
                     [queryParams]="{url: item.artUrl}"><h2 style="white-space: nowrap;" class="overTitle">{{item.title}}</h2><p class="overEll" [innerHTML]="item.subTitle | safeHTML"></p></a>
                </li>
              </span>
              </ul>
            </div>

          </div>
          <!--新闻左右翻 over-->

          <!--搜索框 begin-->
          <div class="indsearchBox">
            <table cellpadding="0" cellspacing="0" border="0" style="width: calc(100% - 40px);">
              <tr>
                <td width="*" nowrap="nowrap" align="left">
                  <div class="indsearchBoxIn" style=" width:100%; height: auto;">
                    <app-search-box [useClass]="0"></app-search-box>
                  </div>
                </td>
                <td width="1%" nowrap="nowrap">
                  <div>
                    <a (click)="check1($event)" target="_blank" [routerLink]="['EstablishArchivesParent/FilingBasicInfo']" class="btnIndFile" title="企业建档"><img src="../../../assets/images/btnIndFileBlue.png"/></a>
                  </div>
                </td>
                <td width="1%" nowrap="nowrap">
                  <div>
                    <a (click)="check($event)" target="_blank" [routerLink]="['BusinessCardParent/EnterpDevelopment']" class="btnIndCard" title="创建名片"><img src="../../../assets/images/btnIndCardBlue.png"/></a>
                  </div>
                </td>
              </tr>
            </table>
          </div>
          <!--搜索框 over-->

          <div class="indFootBox" style="z-index: 1; position: static;margin-right: 7%; width: auto; bottom: initial; margin-top: 30%;">
            <dl class="foot2">
              <dd>
                <table >
                  <tr>
                    <td class="xhsBlue" align="right" valign="top">社会信用体系建设部际联席会议成员单位新华社指导 ┊ 国家发展改革委重点推荐社会信用服务机构
                      <!--<br/> -->┊ 中国经济信息社主办 ┊ 版权所有：新华中经信用管理有限公司 ┊ 京ICP备17069139号</td>
                    <td>&nbsp;&nbsp;
                      <!--间距勿删-->
                    </td>
                    <td align="right" valign="top" style="padding-top: 6px;">
                      <nz-tooltip [nzPlacement]="'topRight'">
                        <div nz-tooltip><img src="../../../assets/images/erweimaS2Blue.png" alt=""/></div>
                        <ng-template #nzTemplate>
                          <img width="85" height="85" src="../../../assets/images/qrcode-base.jpg" alt=""/>
                        </ng-template>
                      </nz-tooltip>
                    </td>
                  </tr>
                </table>
              </dd>
            </dl>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<nz-modal [nzVisible]="isVisible" [nzTitle]="'创建企业名片协议'" [nzContent]="modalContent" [nzFooter]="modalFooter" (nzOnCancel)="handleCancel()">
  <ng-template #modalContent>
    <div class="modal-body" style="height:300px">
      <div class="LoginBox law-box">
        <div class="law-in-box" style="overflow-y:scroll;height: 240px;">
          <p>
            <br/>
          </p>
          <p>
            声明及信息使用授权书
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            新华中经信用管理有限公司：
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位承诺，本单位在新华信用大数据平台网站提供的所有信息及资料，均是真实、准确、完整、最新的信息，无重大遗漏。如本单位提供的信息或资料存在虚假、不准确、或存在重大遗漏，由此所导致的不利后果由本单位承担，包括但不限于赔偿贵司或第三方因此所遭受的任何损失、费用或责任。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位授权贵司在下列情形下，使用本单位在新华信用大数据平台网站上传的全部信息，以及根据《新华信用企业及机构用户服务协议》新华信用大数据平台网站已采集加工的行业协会、政府有关部门、人民法院等公开发布或可供公共查询的关于本单位的信息。同意贵司将最终形成的信用报告进行归档、保存和分析。
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>一、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位申请出具企业信用报告（标准版或深度版）的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>二、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位授权第三方查询本单位非公开信用信息，或申请获取本单位的企业信用报告（标准版或深度版）的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>三、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>处理本单位异议的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>四、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据相关法律法规或政府主管部门的要求提供本单位信息的，或
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>五、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>涉及本单位的其他征信事项的。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本授权书自本单位在新华信用网站的账户提交授权书之日起生效，有效期至本单位注销在在新华信用网站的账户之日止。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位知悉并完全理解上述授权，特此授权。
          </p>
          <p>
            <br/>
          </p>

        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #modalFooter>
    <div style="text-align: center;">
      <a [routerLink]="['/BusinessCardParent/EnterpDevelopment']" target="_blank" (click)="checkProtocol()" class="iDo">阅读并接受</a>
      <button nz-button [nzType]="'default'" [nzSize]="'large'" (click)="handleCancel($event)">返 回</button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal [nzVisible]="isVisible2" [nzTitle]="'创建企业建档协议'" [nzContent]="modalContent2" [nzFooter]="modalFooter2" (nzOnCancel)="handleCancel2()">
  <ng-template #modalContent2>
    <div class="modal-body" style="height:300px">
      <div class="LoginBox law-box">
        <h5>本协议发布（更新）于 2017 年 12 月 12 日</h5>
        <div class="law-in-box" style="overflow-y:scroll;height: 240px;">
          <p>
            <br/>
          </p>
          <p>
            声明及信息使用授权书
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            新华中经信用管理有限公司：
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位承诺，本单位在新华信用大数据平台网站提供的所有信息及资料，均是真实、准确、完整、最新的信息，无重大遗漏。如本单位提供的信息或资料存在虚假、不准确、或存在重大遗漏，由此所导致的不利后果由本单位承担，包括但不限于赔偿贵司或第三方因此所遭受的任何损失、费用或责任。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位授权贵司在下列情形下，使用本单位在新华信用大数据平台网站上传的全部信息，以及根据《新华信用企业及机构用户服务协议》新华信用大数据平台网站已采集加工的行业协会、政府有关部门、人民法院等公开发布或可供公共查询的关于本单位的信息。同意贵司将最终形成的信用报告进行归档、保存和分析。
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>一、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位申请出具企业信用报告（标准版或深度版）的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>二、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>本单位授权第三方查询本单位非公开信用信息，或申请获取本单位的企业信用报告（标准版或深度版）的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>三、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>处理本单位异议的，
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>四、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>根据相关法律法规或政府主管部门的要求提供本单位信息的，或
          </p>
          <p class="MsoListParagraph" style="margin-left:48px">
            <span>五、<span style="font-variant-numeric: normal;font-variant-east-asian: normal;font-stretch: normal;font-size: 9px;line-height: normal;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span></span>涉及本单位的其他征信事项的。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本授权书自本单位在新华信用网站的账户提交授权书之日起生效，有效期至本单位注销在在新华信用网站的账户之日止。
          </p>
          <p>
            <span>&nbsp;</span>
          </p>
          <p>
            本单位知悉并完全理解上述授权，特此授权。
          </p>
          <p>
            <br/>
          </p>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #modalFooter2>
    <div style="text-align: center;">
      <a [routerLink]="['/EstablishArchivesParent/FilingBasicInfo']" target="_blank" (click)="checkProtocol2()" class="iDo">阅读并接受</a>
      <button nz-button [nzType]="'default'" [nzSize]="'large'" (click)="handleCancel2($event)">返 回</button>
    </div>
  </ng-template>
</nz-modal>



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/index/index.component.html